module.exports = __webpack_public_path__ + "static/img/img.f9da8202.jpg";